module.exports = __webpack_public_path__ + "media/recipes/100-590e446b.png";